import {type AgentSubType, Concept} from 'types';

export const DefaultFontSizePct = 120;
export const AgentTypes: AgentSubType[] = [
  Concept.person,
  Concept.corporation,
  Concept.publisher,
  Concept.event,
];
